import {
  Box,
  Container,
  Typography,
  useMediaQuery,
  Rating,
  Divider,
} from "@mui/material";
import React, { useState } from "react";
import { images, icons } from "../../assets";
import { allColors } from "../../constants";
import "react-multi-carousel/lib/styles.css";
import Carousel from "react-multi-carousel";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import ShareIcon from "@mui/icons-material/Share";
import OutlinedFlagIcon from "@mui/icons-material/OutlinedFlag";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const reviewsData = [
  {
    id: 1,
    title: "Savings...",
    rating: 5,
    createdAt: "4 days ago",
    description:
      "Been looking around for a good few months and think I've found a gem of a company, savings are looking top notch. Jimi",
    userDetail: {
      image: images.dummyUserImg1,
      userName: "James",
      dateOfExp: "February 07, 2025",
    },
  },
  {
    id: 2,
    title: "Rubin came to my shop and was very…",
    description:
      "Rubin came to my shop and was very pleasant. Very good experience and seems like a company that won’t rip you off!",
    rating: 5,
    createdAt: "Jan 29, 2025",
    userDetail: {
      image: images.dummyUserImg2,
      userName: "Samantha Westlake",
      dateOfExp: "January 27, 2025",
    },
  },
  {
    id: 3,
    title: "Very Good",
    description:
      "Great guys, very polite and helpful. Refreshing to deal with a company with principles.",
    rating: 5,
    createdAt: "Jan 30, 2025",
    userDetail: {
      image: images.dummyUserImg1,
      userName: "Richard Tague",
      dateOfExp: "January 30, 2025",
    },
  },
  {
    id: 4,
    title: "Impressed",
    description:
      "No complaints so far - very impressed 👍",
    rating: 5,
    createdAt: "Jan 29, 2025",
    userDetail: {
      image: images.dummyUserImg3,
      userName: "customer",
      dateOfExp: "January 29, 2025",
    },
  },
  {
    id: 5,
    title: "Excellent",
    description:
      "Wanted to change providers and they were the best. Very smooth process.",
    rating: 5,
    createdAt: "Jan 28, 2025",
    userDetail: {
      image: images.dummyUserImg3,
      userName: "Tony",
      dateOfExp: "January 27, 2025",
    },
  },
  // {
  //   id: 6,
  //   title: "Meh raj Anwar is an excellent sales…",
  //   description:
  //     "Meh raj Anwar is an excellent sales advisor. He took the time to call back when I was to busy to talk, sorted out everything, giving us confidence in their company. Very polite and an excellent human in this day and age. For now we are still with our existing supplier but when things change he is the one to trust.",
  //   rating: 5,
  //   createdAt: "14 Sept 2023",
  //   userDetail: {
  //     image: images.dummyUserImg3,
  //     userName: "Pamela Sweetland",
  //     dateOfExp: "11 September 2023",
  //   },
  // },
  // {
  //   id: 7,
  //   title: "No pressure put on me regarding a purchase",
  //   description:
  //     "Spoke with Tapas on a few occasions! What a lovely genuine gentleman. He took time to explain everything I need to know at my pace. He is very knowledgeable and friendly. There was no pressure what so ever from him. He is a credit to his company, in my opinion he defiantly goes the extra mile!!! Thanks Tapas I shall recommend you Enjoy the weekend with your family",
  //   rating: 5,
  //   createdAt: "15 Sept 2023",
  //   userDetail: {
  //     image: images.dummyUserImg3,
  //     userName: "ib",
  //     dateOfExp: "15 September 2023",
  //   },
  // },
  // {
  //   id: 8,
  //   title: "Delt with a man called Ronit",
  //   description:
  //     "Delt with a man called Ronit, excelent person to deal with. Had a little setup problem mainly due to communications with BT Openreach. The company has been very suportive. Jim Wyatt ( FIRE ALARM development)",
  //   rating: 5,
  //   createdAt: "31 Aug 2023",
  //   userDetail: {
  //     image: images.dummyUserImg3,
  //     userName: "Jim Wyatt",
  //     dateOfExp: "31 August 2023",
  //   },
  // },
  // {
  //   id: 9,
  //   title: "Excellent customer service.",
  //   description:
  //     "Prasenjit and team went above and beyond after hours to assist with getting broadband set up. Prasnejit was calm and patient explaining everything clearly. The other parts of this team were focused and supportive in sorting out accounts. This is not the first time we have had excellent service from this company.",
  //   rating: 5,
  //   createdAt: "19 Aug 2023",
  //   userDetail: {
  //     image: images.dummyUserImg3,
  //     userName: "john charlton",
  //     dateOfExp: "18 August 2023",
  //   },
  // },
  // {
  //   id: 10,
  //   title: "Praveen called to let me know about…",
  //   description:
  //     "Praveen called to let me know about Trust Telecom's openreach phone services and he was very helpful and although I did not sign up this was because I required a VOIP service. Praveen advised that this service would soon be available and so he will be calling me back in due course.",
  //   rating: 5,
  //   createdAt: "8 Aug 2023",
  //   userDetail: {
  //     image: images.dummyUserImg3,
  //     userName: "Hi",
  //     dateOfExp: "07 August 2023",
  //   },
  // },
];

const TrustPilot = () => {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1180 },
      items: 4,
      slidesToSlide: 1, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1180, min: 600 },
      items: 3,
      slidesToSlide: 1, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 600, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  const ButtonGroup = ({ next, previous, goToSlide, ...rest }) => {
    const {
      carouselState: { currentSlide },
    } = rest;
    return (
      <>
        <img
          src={icons.carouselLeftArrowDark}
          style={{
            width: "35px",
            height: "35px",
            cursor: "pointer",
            position: "absolute",
            top: "50%",
            left: isSmallScreen ? "-10px" : "-20px",
          }}
          onClick={() => previous()}
        />
        <img
          src={icons.carouselRightArrowDark}
          style={{
            width: "35px",
            height: "35px",
            cursor: "pointer",
            position: "absolute",
            top: "50%",
            right: isSmallScreen ? "-10px" : "-20px",
          }}
          onClick={() => {
            next();
          }}
        />
      </>
    );
  };
  return (
    <Box
      sx={{
        background: allColors.brightGray,
      }}
      id="trust-pilot"
    >
      <Container
        sx={{
          textAlign: "center",
          maxWidth: "1400px !important",
          marginTop: "50px",
          paddingTop: "40px",
          paddingBottom: "40px",
          position: "relative",
        }}
      >
        <img
          src={images.trustPilotImg}
          style={{ width: isSmallScreen ? "60%" : "30%", height: "100%" }}
        />

        <Typography
          sx={{
            fontFamily: "Raleway",
            fontWeight: "600",
            fontSize: { xs: "22px", sm: "30px", md: "50px" },
            margin: "10px 0",
          }}
        >
          Unparalleled Customer Service
        </Typography>
        <Typography
          sx={{
            fontFamily: "Raleway",
            fontWeight: "400",
            fontSize: { xs: "15px", md: "20px" },
          }}
        >
          Just ask our customers...
        </Typography>

        <Box
          sx={{
            // background: allColors.floralWhite,
            position: "relative",
            padding: "15px",
            marginTop: { xs: "30px", sm: "50px" },
          }}
        >
          <Carousel
            swipeable={true}
            draggable={false}
            showDots={false}
            responsive={responsive}
            ssr={false} // means to render carousel on server-side.
            infinite={true}
            arrows={false}
            showStatus={false}
            autoPlay={true}
            interval={4000}
            renderDotsOutside={false}
            keyBoardControl={true}
            // centerMode={isSmallScreen ? true : false}
            transitionDuration={1000}
            renderButtonGroupOutside={true}
            removeArrowOnDeviceType={["tablet"]}
            containerClass="carousel-container"
            dotListClass="custom-dot-list-style"
            itemClass="carousel-item-padding-40-px"
            customButtonGroup={<ButtonGroup />}
          >
            {reviewsData.map((itemmmmm, indddd) => {
              return (
                <div
                  style={{
                    padding: "15px",
                    background: allColors.white,
                    marginLeft: "20px",
                    marginRight: "20px",
                    borderRadius: "5px",
                    textAlign: "left",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "12px",
                    }}
                  >
                    <img
                      src={itemmmmm.userDetail.image}
                      style={{
                        width: "50px",
                        height: "50px",
                        borderRadius: "50%",
                        marginRight: "10px",
                      }}
                    />
                    <Box sx={{ marginLeft: "10px" }}>
                      <Typography
                        sx={{
                          fontWeight: 600,
                          fontSize: "14px",
                          color: allColors.jetBlack,
                        }}
                      >
                        {itemmmmm.userDetail.userName}
                      </Typography>
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        <Typography
                          sx={{
                            fontWeight: 400,
                            fontSize: "14px",
                            color: allColors.jetBlack,
                          }}
                        >
                          1 review
                        </Typography>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginLeft: "12px",
                          }}
                        >
                          <img
                            src={icons.locationIcon}
                            style={{
                              width: "15px",
                              height: "16px",
                            }}
                          />
                          <Typography
                            sx={{
                              fontWeight: 400,
                              fontSize: "13px",
                              color: allColors.jetBlack,
                              marginLeft: "4px",
                            }}
                          >
                            Share
                          </Typography>
                        </Box>
                      </Box>
                    </Box>
                  </Box>

                  <Divider sx={{ marginBottom: "15px" }} />

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Rating
                      name="half-rating"
                      defaultValue={itemmmmm.rating}
                      precision={0.5}
                      readOnly
                      size={"small"}
                      sx={{
                        "& > span": {
                          background: allColors.greenMunsell,
                          marginRight: "2px",
                          padding: "2px",
                          color: allColors.white,
                        },
                      }}
                    />
                    <Typography
                      sx={{
                        fontWeight: 400,
                        fontSize: "13px",
                        color: allColors.jetBlack,
                        marginLeft: "15px",
                      }}
                    >
                      {itemmmmm.createdAt}
                    </Typography>
                  </Box>
                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "16px",
                      color: allColors.jetBlack,
                      marginTop: "10px",
                    }}
                  >
                    {itemmmmm.title}
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: "13px",
                      color: allColors.jetBlack,
                      marginTop: "10px",
                    }}
                  >
                    {itemmmmm.description.length > 200
                      ? `${itemmmmm.description.substring(0, 200)}...`
                      : itemmmmm.description}
                  </Typography>

                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: "13px",
                      color: allColors.jetBlack,
                      marginTop: "10px",
                    }}
                  >
                    Date of experience:{" "}
                    <span style={{ fontWeight: "400" }}>
                      {itemmmmm.userDetail.dateOfExp}
                    </span>
                  </Typography>

                  <Divider sx={{ margin: "15px 0" }} />

                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                        }}
                      >
                        <img
                          src={icons.thumbsUpIcon}
                          style={{
                            width: "16px",
                            height: "16px",
                          }}
                        />
                        <Typography
                          sx={{
                            fontWeight: 400,
                            fontSize: "13px",
                            color: allColors.jetBlack,
                            marginLeft: "6px",
                          }}
                        >
                          Useful
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          marginLeft: "12px",
                        }}
                      >
                        <img
                          src={icons.shareIcon}
                          style={{
                            width: "16px",
                            height: "16px",
                          }}
                        />
                        <Typography
                          sx={{
                            fontWeight: 400,
                            fontSize: "13px",
                            color: allColors.jetBlack,
                            marginLeft: "6px",
                          }}
                        >
                          Share
                        </Typography>
                      </Box>
                    </Box>
                    <img
                      src={icons.flagIcon}
                      style={{
                        width: "16px",
                        height: "16px",
                        marginLeft: "6px",
                      }}
                    />
                  </Box>
                </div>
              );
            })}
          </Carousel>
        </Box>
      </Container>
    </Box>
  );
};

export default TrustPilot;
